/* eslint-disable camelcase */
export function arraysEqualAsSets(a = [], b = []) {
    const aa = [...a].sort((x, y) => x - y);
    const bb = [...b].sort((x, y) => x - y);

    return aa.length === bb.length && aa.every((val, index) => val === bb[index]);
}

export function getMealText(meal, fallbackLabel) {
    const text = (meal?.besk ?? '').trim();

    if (!text) return '';
    if (text.toLowerCase() === fallbackLabel.toLowerCase()) return '';

    return text;
}

export function getMealSummary(lunsj_dager = [], middag_dager = [], draft) {
    const selectedLunsjer = lunsj_dager.filter(d => draft.lunsjer.includes(d.dato));
    const selectedMiddager = middag_dager.filter(d => draft.middager.includes(d.dato));

    const lunsjCount = selectedLunsjer.length;
    const middagCount = selectedMiddager.length;

    const lunsjTotal = selectedLunsjer.reduce((sum, meal) => sum + (Number(meal.pris) || 0), 0);
    const middagTotal = selectedMiddager.reduce((sum, meal) => sum + (Number(meal.pris) || 0), 0);

    return {
        lunsj: {
            count: lunsjCount,
            total: lunsjTotal
        },
        middag: {
            count: middagCount,
            total: middagTotal
        },
        grandTotal: lunsjTotal + middagTotal
    };
}
